import { FC, ReactNode } from "react";
import { IconType } from "react-icons";
import { MdOutlineDevices, MdOutlineLanguage, MdOutlineStorefront, MdOutlineTouchApp } from "react-icons/md";
import clsx from "clsx";

const REDEMPTION_CHANNEL_ICONS: Record<string, IconType> = {
  Online: MdOutlineLanguage,
  InStore: MdOutlineStorefront,
  OnlineAndInStore: MdOutlineDevices,
  SelfRedemption: MdOutlineTouchApp,
};

type Props = {
  channel: string;
  label: ReactNode;
  className?: string;
};

const RedemptionChannelTag: FC<Props> = ({ channel, label, className }) => {
  const Icon = REDEMPTION_CHANNEL_ICONS[channel];

  return (
    <div
      className={clsx(
        "border-secondary-20 bg-secondary-10 text-secondary-70 inline-flex shrink-0 items-center gap-1.5 rounded-full border px-2 md:px-3 py-1 text-xs font-medium",
        className,
      )}
    >
      {Icon && <Icon className="h-4 w-4 shrink-0" />}
      <span>{label}</span>
    </div>
  );
};

export default RedemptionChannelTag;
